import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-admin-articles',
  standalone: false,
  templateUrl: './admin-articles.component.html',
  styleUrl: './admin-articles.component.css'
})
export class AdminArticlesComponent implements OnInit{

  articles: any = [];
  authToken = localStorage.getItem('auth');
  isLoading = false;
  selectedBusiness: any;


  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private authService: AuthService) {
  }

  ngOnInit(): void {
    this.fetchArticles();
  }

  fetchArticles() {
    this.http.get(environment.ADMIN_ARTICLES, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.articles = res.message;

        }
        else {
          console.log('ei ole kyseistä käyttäjää')
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }

  updateArticles(){
    this.isLoading = true;
    this.http.get(environment.ADMIN_UPDATE_ARTICLES, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.isLoading = false;
          alert('Artikkelit päivitetty')
          this.fetchArticles();

        }
        else {
          console.log('ei ole kyseistä käyttäjää')
          this.isLoading = false;
          alert('Artikkelien päivitys epäonnistui. Soita IT-tuelle');
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }

  openLink(link){
    window.open(link, '_blank')
  }

}
